import httpClient from '@/_shared/http-client';
import { date } from "@/_shared/utils";

const PRIMARY_SLUG = 'work_shift';

const get = async() => {
  const url = new URL(`/${PRIMARY_SLUG}`, process.env.BACKEND_URL);
  const params = _prepareMainData();
  for (let paramName in params) {
    url.searchParams.set(paramName, params[paramName]);
  }
  const response = await httpClient.get(url);
  return response;
};

const start = async() => {
  const body = _prepareMainData();
  const url = `/${PRIMARY_SLUG}/start`;
  const response = await httpClient.post(url, body)
    .then(({ data }) => {
      return data.record.start_date;
    })
    .catch(({ response }) => {
      throw new Error (response.data.message);
    });
  return response;
};

const end = async() => {
  const body = _prepareMainData();
  body.end_date = date.getIsoString();
  const url = `/${PRIMARY_SLUG}/end`;
  const response = await httpClient.patch(url, body)
    .then(({ data }) => {
      return data.record.end_date;
    })
    .catch(({ response }) => {
      throw new Error (response.data.message);
    });
  return response;
};

const _prepareMainData = () => {
  const data = {
    user_id: 1,
    start_date: date.getIsoString(),
  };
  return data;
};

export const workShiftService = {
  get,
  start,
  end,
};



// WEBPACK FOOTER //
// ./src/_shared/api-services/workShiftService.js